import { CheckboxModel, SelectModel } from './common.model';

/**
 * Inicializaión de la clase PldModel
 *
 * *Set PldModel class*
 *
 * @access public
 * @type {class}
 */
export class PldModel {
  /**
   * Fuente de la cuenta
   *
   * *Account Source*
   *
   * @var {CheckboxModel[]} accountSource
   */
  accountSource: CheckboxModel[];
  /**
   * Propósito de la cuenta
   * Account Porpuse
   *
   * @var {CheckboxModel[]} accountPurpose
   */
  accountPurpose: CheckboxModel[];
  /**
   * Cuotas
   *
   * @var {string} cuotas
   */
  cuotas: string;
  /**
   * Otros Gastos
   *
   * *Other expenses*
   *
   * @var {string} otrosGastos
   */
  otrosGastos: string;
  /**
   * Instancia de profession como un SelecModel()
   *
   * *Instance of profession as SelectModel()*
   *
   * @var {SelectModel} profession
   */
  profession: SelectModel = new SelectModel();
  /**
   * Nombre del valor
   *
   * *Name Value*
   *
   * @var {string} nameValue
   */
  nameValue: string;
  /**
   * Número de teléfono del usuario
   *
   * *User's Phone Number*
   *
   * @var {string} phoneNumber
   */
  phoneNumber: string;
  /**
   * Prefijo del númeor de teléfono del usuario
   * *User's Phone Number Prefix*
   *
   * @var {string} phonePrefix
   */
  phonePrefix: string;
  /**
   * Identificación del prefijo personal del usuario
   *
   * *User's Personal Prefix Id*
   *
   * @var {number} personalPrefixId
   */
  personalPrefixId: number;
  /**
   * Validación de persona publicamente expuesta
   *
   * *Public exposed person validation*
   *
   * @var {boolean} pep
   */
  pep: boolean;
  /**
   * Fatca
   *
   * @var {boolean} fatca
   */
  fatca: boolean;
  /**
   * Valores pasivos del usuario
   *
   * *User's Passive Value*
   *
   * @var {string} passiveValue
   */
  passiveValue: string;
  /**
   * Valores Áctivos del usuario
   *
   * *Active Value*
   *
   * @var {string} activeValue
   */
  activeValue: string;
}
